import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import Cookies from 'js-cookie'

import { isJwtValid } from '../../common/utils/utils'
import { jwtKey, mehiAvCookie } from '../../constants'

export const teliaJWTSessionStorageKey = 'teliaJWT'

const rawSessionStorage = {
  getItem(key: string, initialValue: string | null) {
    return sessionStorage.getItem(key) ?? initialValue
  },
  setItem(key: string, value: string | null) {
    if (value === null) {
      sessionStorage.removeItem(key)
    } else {
      sessionStorage.setItem(key, value)
    }
  },
  removeItem(key: string) {
    sessionStorage.removeItem(key)
  },
}

export const teliaJWTAtom = atomWithStorage<string | null>(
  teliaJWTSessionStorageKey,
  null,
  rawSessionStorage,
  { getOnInit: true }
)

export type LoginStatus = 'authenticated' | 'impersonated' | 'external' | undefined

const getInitialLoginStatus = (): LoginStatus => {
  const hasJwt =
    Boolean(sessionStorage.getItem(jwtKey)) && isJwtValid(sessionStorage.getItem(jwtKey))
  const hasImpersonationJwt =
    hasJwt &&
    !sessionStorage.getItem(jwtKey)?.startsWith('Test') &&
    !sessionStorage.getItem(jwtKey)?.startsWith('External') &&
    !sessionStorage.getItem(jwtKey)?.startsWith('Partner')
  const hasTestJwt = hasJwt && sessionStorage.getItem(jwtKey)?.startsWith('Test')
  const hasExtJwt =
    hasJwt &&
    (sessionStorage.getItem(jwtKey)?.startsWith('External') ||
      sessionStorage.getItem(jwtKey)?.startsWith('Partner'))
  const hasCookieAuth = Cookies.get(mehiAvCookie)

  if (hasCookieAuth || hasTestJwt) {
    return 'authenticated'
  } else if (hasImpersonationJwt) {
    return 'impersonated'
  } else if (hasExtJwt) {
    return 'external'
  }

  return undefined
}

export const loginStatusAtom = atom<LoginStatus>(getInitialLoginStatus())

export type OHCAllowance = 'allowed' | 'disallowed' | 'online_reservation_denied'
export const ohcAllowedStatusAtom = atom<OHCAllowance | null>(null)

export const reservationConfirmationEmailAtom = atom<string | null>(null)

export const reservationConfirmationContactByPhoneAtom = atom<boolean | undefined>(undefined)
